function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M25.38 17.227c0-5.1-4.113-9.272-9.142-9.272-5.028 0-9.143 4.172-9.143 9.272 0 4.328 2.895 7.96 6.857 8.964v1.855h4.572V26.19c3.962-1.005 6.857-4.636 6.857-8.964zM17 34.227h-1.524M18.524 31.137h-4.572M16.238 1.773v3.09M31.476 17.227H28.43M1 17.227h3.048M4.352 5.173L7.63 8.496M28.124 5.173l-3.276 3.323",
    stroke: props.color,
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgLightbulb;